export const substituteConceptPlaceholders = (
  text: string,
  concept: { title: string | null; description: string | null }
): string =>
  text
    .replaceAll("{{concept.title}}", concept.title ?? "")
    .replaceAll("{{concept.description}}", concept.description ?? "");
